export default __webpack_public_path__ + "static/media/avgConsumptionIcon.d36b2a91.svg";